<template>
  <v-container id="upload_file_list__archivos_firmar__container" class="py-0">
    <v-row no-gutters>
      <v-col>
        <v-row no-gutters>
          <v-col id="upload_file_list__ubicacion_archivo__menu_tree" cols="10" class="pr-5">
            <folder-picker
              :value="currentItem.folder.idCarpeta"
              @change="setFolder"
            ></folder-picker>
          </v-col>

          <v-col cols="2">
            <expiration-date
              id="upload_file_list__fecha_expiracion__date_picker"
              v-model="currentItem.fechaExpiracion"
              @change="setFechaExpiracion"
            ></expiration-date>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col cols="6" class="pr-5">
            <v-text-field
              id="upload_file_list__nombre__text"
              name="upload_file_list__nombre__text"
              ref="nombreTextField"
              v-model="currentItem.descripcion"
              label="Nombre"
              required
              :rules="[nombreRequerido, max100chars, notCharSpecial]"
              @keyup="setDescripcion()"
            ></v-text-field>
          </v-col>
          <v-col cols="4" class="pr-5">
            <document-type-combo
              id="upload_file_list__tipo_documento__combo"
              ref="comboTypeDocument"
              v-model="currentItem.tipoDocumento"
              @change="setTipoDocumento"
              :rules="[tipoRequerido]"
              required
            ></document-type-combo>
          </v-col>
          <v-col cols="2">
            <v-text-field
              id="upload_file_list__clave__text"
              name="upload_file_list__clave__text"
              ref="claveTextField"
              v-model="currentItem.clave"
              label="Clave"
              :rules="[max15chars, notSpecialCharsPunctuation]"
              @keyup="setClave()"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="offset-md-1" cols="10">
            <v-card class="mr-8" min-height="230px" id="upload_file_list__documentos__card">
              <v-card-title class="py-1">
                <h6>Documentos</h6>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-data-table
                  :headers="fileHeaders"
                  :items="fileList"
                  :loading="isUploading"
                  :items-per-page="4"
                  :footer-props="{'items-per-page-options': [4]}"
                  dense
                >
                  <template v-slot:item="{ item }">
                    <tr
                      :class="isSelectedRow(item) ? 'teal lighten-3' : ''"
                      :key="item.id"
                    >
                      <td><v-icon v-if="isSelectedRow(item)">{{ icon.arrow }}</v-icon></td>
                      <td @click="rowClicked(item)">{{ item.nombre }}</td>
                      <td>
                        <v-icon
                          :id="'upload_file_list__documentos__close_'+item.id"
                          small
                          @click="deleteItem(item)"
                          :disabled="isUploading"
                          >{{ icon.close }}</v-icon
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mdiArrowRightBoldOutline, mdiCloseCircle } from '@mdi/js'
import {
  uploadWizardData,
  uploadWizardActions
} from '@/modules/documents/store/uploadWizardStoreHelpers'
import { documentsActions } from '@/modules/documents/store/documentsHelpers'
import { folderStoreData } from '@/modules/catalogs/store/folderStoreHelpers'
import FolderPicker from '@/modules/catalogs/components/FolderPicker'
import ExpirationDate from '@/modules/documents/components/ExpirationDate'
import DocumentTypeCombo from '@/modules/catalogs/components/DocumentTypeCombo'

export default {
  name: 'UploadFileList',
  components: {
    FolderPicker,
    ExpirationDate,
    DocumentTypeCombo
  },
  data() {
    return {
      icon: {
        arrow: mdiArrowRightBoldOutline,
        close: mdiCloseCircle
      },
      nombreRequerido: v => v.length > 0 || 'El Nombre es requerido.',
      tipoRequerido: v => {
        if(typeof v === 'string'){
          return 'El Tipo de Documento contiene un valor incorrecto.'
        } 
        return !!v || 'El Tipo de Documento es requerido.'
      },
      max100chars: v =>
        v.length <= 100 || 'La Descripción solo puede tener 100 caracteres.',
      max15chars: v =>
        v.length <= 15 || 'La Clave solo puede tener 15 caracteres.',
      notCharSpecial: v => {
        if (v === '') return true
        const regx = /^[^|¿?¡!^~<>¨´\[\]\{\}`¬\°]{1,254}$/

        return (
          regx.test(v) ||
          'El texto no debe contener caracteres especiales (¿?¡!^~<>¨´[]{}`¬°).'
        )
      },
      notSpecialCharsPunctuation: v => {
        if (v === '') return true
        const regx = /^[^|#¿?¡!$%^*~+*/\\<>=¨´\[\]\{\}`¬\°\-@\.\:\;\,]{1,100}$/

        return (
          regx.test(v) ||
          'El texto no debe contener caracteres especiales (#¿?¡!$%^~+*/\<>=¨´[]{}`¬°-@:;,).'
        )
      }
    }
  },
  created() {
    this.setExpirationDate(this.datePicker)
  },
  computed: {
    ...uploadWizardData,
    ...folderStoreData,
    fileList: {
      get() {
        return _.map(this.files, function(f) {
          return {
            ...f
          }
        })
      },
      set(value) {
        this.setFiles(value)
      }
    }
  },
  watch: {
    dialogUploadWizard: function(val) {
      if (val) {
        this.$refs.nombreTextField.resetValidation()
        this.$refs.comboTypeDocument.reset()
        this.$refs.claveTextField.resetValidation()
        this.validateStepOne()
      }
    }
  },
  methods: {
    ...uploadWizardActions,
    ...documentsActions,
    deleteItem(item) {
      this.removeFile(item)
      this.validateStepOne()
    },
    rowClicked(item) {
      if (item !== this.currentItem) {
        let selectedRows = []
        selectedRows.push(item)
        this.setSelectedItems(selectedRows)
        this.setCurrentItem({
          nombre: item.nombre,
          descripcion: item.descripcion,
          clave: item.clave,
          tipoDocumento: item.tipoDocumento,
          folder: item.folder,
          fechaExpiracion: item.fechaExpiracion
        })
      }
      this.validateStepOne()
    },
    isSelectedRow(item) {
      if (this.selectedItems.length > 0) {
        const nombre = this.selectedItems[0].nombre
        return nombre === item.nombre
      }

      return false
    },
    setDescripcion() {
      this.updateFields({
        nombre: this.currentItem.nombre,
        descripcion: this.$refs.nombreTextField.valid ? this.currentItem.descripcion : ''
      })

      this.validateStepOne()
    },
    setClave() {
      this.updateFields({
        nombre: this.currentItem.nombre,
        clave: this.$refs.claveTextField.valid ? this.currentItem.clave : null
      })

      this.validateStepOne()
    },
    setTipoDocumento(value) {
      this.updateFields({
        nombre: this.currentItem.nombre,
        tipoDocumento: value
      })

      this.validateStepOne()
    },
    setFolder(value) {
      if (this.currentItem.folder.idCarpeta != value.idCarpeta) {
        this.currentItem.folder = value
        this.updateFields({
          nombre: this.currentItem.nombre,
          folder: value
        })
      }
    },
    setFechaExpiracion(value) {
      this.updateFields({
        nombre: this.currentItem.nombre,
        fechaExpiracion: value
      })
    },
    validateStepOne() {
      let valid = true
      this.files.forEach(element => {
        valid = valid &&
          element.folder != null && 
          element.folder.idCarpeta != null &&
          element.folder.idCarpeta.length > 0 &&
          element.fechaExpiracion.length > 0 &&
          element.descripcion.length > 0 &&
          !!element.tipoDocumento &&
          element.tipoDocumento.length > 0 &&
          element.clave != null
      });
      
      this.setIsValidStepOne(valid)
    }
  }
}
</script>

<style scoped>
.theme--dark.v-sheet .v-alert { color: #000}
</style>